import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { isRejectedWithValue } from "@reduxjs/toolkit";
import toast from "react-hot-toast";
import { userApi } from "./services/user-service.js";
import { partnerPlanApi } from "./services/partner-plan-service.js";
import reducers from "store/reducers/index.js";
import { authApi } from "services/auth-service.js";
import {
  removeAuthToken,
  removeUserAccessToken,
} from "utils/localstorage.helper.js";
import { accountApi } from "services/account-service.js";
import { campaignsApi } from "services/campaign-service.js";
import { leadsApi } from "services/leads-service.js";
import { planApi } from "services/userPlan-service.js";
import { leadUsageApi } from "services/lead-usage-service.js";
import { analyticsApi } from "services/analytics.js";
import { dfyApi } from "services/dfy-service.js";

export const rtkQueryErrorLogger = () => (next) => async (action) => {
  // RTK Query uses `createAsyncThunk` from redux-toolkit under the hood, so we're able to utilize these matchers!
  if (
    isRejectedWithValue(action) &&
    action.payload?.data?.error?.message === "Invalid auth token"
  ) {
    removeAuthToken();
    removeUserAccessToken();
    toast.error("Session expired!", { id: 'expiredToast' });
    window.location.reload();
  }

  return next(action);
};

export const store = configureStore({
  reducer: reducers,

  // {
  //   // Add the generated reducer as a specific top-level slice
  //   [userApi.reducerPath]: userApi.reducer,
  // },
  // Adding the api middleware enables caching, invalidation, polling,
  // and other useful features of `rtk-query`.
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(planApi.middleware)
      .concat(userApi.middleware)
      .concat(partnerPlanApi.middleware)
      .concat(authApi.middleware)
      .concat(accountApi.middleware)
      .concat(campaignsApi.middleware)
      .concat(leadsApi.middleware)
      .concat(leadUsageApi.middleware)
      .concat(analyticsApi.middleware)
      .concat(dfyApi.middleware)
      .concat(rtkQueryErrorLogger),
});

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch);
